import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GetRequestResponseItem } from '@schema/APITypes';

@Component({
  selector: 'lgv-request-table-more-item',
  template: `
    <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item (click)="editClicked.emit()">
        <mat-icon class="material-icons-outlined">edit</mat-icon>
        <span translate>shared_component_generictable_edit</span>
      </button>
      @if (item.status !== 'confirmed') {
        <button
          mat-menu-item
          [disabled]="item.hasAccount"
          matTooltipPosition="before"
          [matTooltip]="'shared_component_generictable_delete_disabled' | translate"
          [matTooltipDisabled]="!item.hasAccount"
          (click)="deleteClicked.emit()"
        >
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span translate>shared_component_generictable_delete</span>
        </button>
      }
      @if (item.status === 'confirmed') {
        <button mat-menu-item (click)="archiveClicked.emit()">
          <mat-icon class="material-icons-outlined">archive</mat-icon>
          <span translate>shared_component_generictable_archive</span>
        </button>
      }
      @if (item.status === 'archived') {
        <button mat-menu-item (click)="unarchiveClicked.emit()">
          <mat-icon class="material-icons-outlined">unarchive</mat-icon>
          <span translate>shared_component_generictable_reactivate</span>
        </button>
      }
    </mat-menu>
  `,
  standalone: false,
})
export class RequestTableMoreItemComponent {
  @Input() item: GetRequestResponseItem;
  @Output() editClicked = new EventEmitter();
  @Output() deleteClicked = new EventEmitter();
  @Output() archiveClicked = new EventEmitter();
  @Output() unarchiveClicked = new EventEmitter();
}
